import { useOutletContext } from 'react-router-dom';
import MonthlyPrime from '../organisms/MonthlyPrime';

export type PrimesOutletContext =
  | {
      tamEmail: string;
      tamDisplayName: string;
      referenceDate: Date;
    }
  | undefined;

const PrimesMonthlyPage = () => {
  const outletContext = useOutletContext<PrimesOutletContext>();

  return (
    <MonthlyPrime
      key={`${outletContext?.tamEmail ?? 'admin'}-${outletContext?.referenceDate?.toISOString() ?? 'current'}`}
      tamEmail={outletContext?.tamEmail}
      tamDisplayName={outletContext?.tamDisplayName}
      referenceDate={outletContext?.referenceDate}
    />
  );
};

export default PrimesMonthlyPage;
